import { useState } from 'react';

import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';
// Components
import LayoutSignUpPublic from '@/components/layouts/LayoutSignUpPublic';
import SignUpForm from '@/components/pages/signup/createAccount/SignUpForm';

const SignUpAccount = () => {
    const { t } = useTranslation('commons');
    const [isWithEmail, setIsWithEmail] = useState(false);

    return (
        <LayoutSignUpPublic
            titleLocale={!isWithEmail ? 'title' : 'with_email_title'}
            subTitleLocale={!isWithEmail ? 'subtitle' : null}
            headerChildren={
                isWithEmail ? (
                    <button
                        className="absolute -top-7 left-0 flex items-center text-xs text-icoGray-500"
                        onClick={() => {
                            setIsWithEmail(false);
                        }}>
                        <Icon icon="chevron-left" className="mr-1.5 text-icoGray-400" />
                        {t('back')}
                    </button>
                ) : null
            }
            displayFooter={!isWithEmail}>
            <SignUpForm isWithEmail={isWithEmail} setIsWithEmail={setIsWithEmail} />
        </LayoutSignUpPublic>
    );
};

export const getStaticProps = TranslationService.getTranslationMessages('signup_funnel');

export default SignUpAccount;
